// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"9c0cbd7c","421":"2b72abc7","463":"99a4f177","589":"dda173bf","742":"4db2ccad","898":"26858f25"}[chunkId] + ".chunk.js";
};